(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["FileUpload"] = factory();
	else
		root["FileUpload"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _FileUpload = __webpack_require__(3);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  FileUpload: _FileUpload2.default
	};

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'fileupload',
	  props: {
	    target: {
	      type: String
	    },
	    action: {
	      type: String,
	      default: 'POST'
	    }
	  },
	  data: function data() {
	    return {
	      file: null
	    };
	  },
	
	  methods: {
	    emitter: function emitter(event, data) {
	      this.$emit(event, data);
	    },
	    uploadProgress: function uploadProgress(oEvent) {
	      var vm = this;
	      if (oEvent.lengthComputable) {
	        var percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total);
	        vm.emitter('progress', percentComplete);
	      } else {
	        vm.emitter('progress', false);
	      }
	    },
	    onFileChange: function onFileChange(e) {
	      var vm = this;
	
	      if (!this.target || this.target === '') {
	        console.log('Please provide the target url');
	      } else if (!this.action || this.action === '') {
	        console.log('Please provide file upload action ( POST / PUT )');
	      } else if (this.action !== 'POST' && this.action !== 'PUT') {
	        console.log('File upload component only allows POST and PUT Actions');
	      } else {
	        var files = e.target.files || e.dataTransfer.files;
	
	        if (!files.length) {
	          return;
	        };
	
	        this.file = files[0];
	        var formData = new FormData();
	        formData.append('file', this.file);
	
	        var xhr = new XMLHttpRequest();
	        xhr.open(this.action, this.target);
	
	        xhr.onloadstart = function (e) {
	          vm.emitter('start', e);
	        };
	        xhr.onloadend = function (e) {
	          vm.emitter('finish', e);
	        };
	        xhr.upload.onprogress = vm.uploadProgress;
	        xhr.send(formData);
	      }
	    }
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = " <input type=file name=fileUpload @change=onFileChange> ";

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(1)
	__vue_template__ = __webpack_require__(2)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// vue-simple-upload.min.js